module.exports = __webpack_public_path__ + "img/sustainable_land.72b217fe.svg";